module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0